'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS'
};

function loginRequest() {
    return {
        type: actionTypes.LOGIN_REQUEST
    };
}

function loginSuccess(userEmail) {
    return {
        type: actionTypes.LOGIN_SUCCESS,
        userEmail: userEmail
    };
}

function loginFailed(errorMessage) {
    return {
        type: actionTypes.LOGIN_FAILED,
        errorMessage: errorMessage
    };
}

function logoutRequest() {
    return {
        type: actionTypes.LOGOUT_REQUEST
    };
}

function logoutSuccess() {
    return {
        type: actionTypes.LOGOUT_SUCCESS
    };
}

var actionCreators = {
    loginRequest: loginRequest,
    loginSuccess: loginSuccess,
    loginFailed: loginFailed,
    logoutRequest: logoutRequest,
    logoutSuccess: logoutSuccess
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/auth.js
// module id = 262
// module chunks = 0